import { message } from "antd"
import axios from "axios"
import getErrorMessage from "./getErrorMessage"

// ВАЖНО: это ветка erp1 — система erp1.zendig.uz.
// Здесь НЕ должно быть адресов второй системы (AIGA / ittec.uz): раньше в
// бандле лежали адреса обеих, и та же сборка, открытая на чужом домене,
// уходила в чужой API и чужую базу. Адреса AIGA задаются в ветке master;
// общий запасной вариант — REACT_APP_* из .env.production.
function isErp1Host(): boolean {
  if (typeof window === "undefined" || !window.location) return false
  const host = window.location.hostname.toLowerCase()
  return host.includes("erp1") || host.includes("zendig.uz")
}

export function getBaseApiUrl(): string {
  if (isErp1Host()) {
    return "https://apierp1.zendig.uz/api/"
  }
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL
  }
  return process.env.NODE_ENV === "production"
    ? "https://apierp1.zendig.uz/api/"
    : "http://localhost:5000/api/"
}

export function getSiteUrl(): string {
  if (isErp1Host()) {
    return "https://erp1.zendig.uz"
  }
  return process.env.REACT_APP_SITE_URL || ""
}

export function getWsUrl(): string {
  if (isErp1Host()) {
    return "wss://apierp1.zendig.uz/"
  }
  return process.env.REACT_APP_WS_URL || "ws://localhost:5000/"
}

export function getMediaUrl(): string {
  const api = getBaseApiUrl()
  return api.replace(/\/api\/?$/, "") + "/media/"
}

export const API_URL = getBaseApiUrl()
export const SITE_URL = getSiteUrl()
export const WS_URL = getWsUrl()
export const MEDIA_URL = getMediaUrl()

const client = axios.create({ baseURL: API_URL })

export const request = ({ ...options }) => {
  let auth = localStorage.getItem("accessToken")
    ? `Bearer ${localStorage.getItem("accessToken")}`
    : ""
  client.defaults.baseURL = getBaseApiUrl()
  client.defaults.headers.common.Authorization = auth
  client.defaults.headers.common.Accept = "application/json"

  const onSuccess = (response: any) => {
    return response
  }
  const onError = (error: any) => {
    // Бизнес-ошибку (400/409 с телом { code, message }) показывает форма,
    // которая знает контекст. Здесь — только то, что иначе никто не покажет:
    // обрыв связи и неожиданные сбои сервера. Раньше на каждую ошибку тут
    // всплывало техническое «Request failed with status code 500, Sales/ArraySale»,
    // а форма поверх него показывала ещё одно, всегда одинаковое сообщение.
    const status = error?.response?.status
    const body = error?.response?.data
    const isHandledBusinessError =
      status >= 400 && status < 500 && body && (body.code || body.message || body.errors)

    if (!isHandledBusinessError) {
      message.error(getErrorMessage(error, `${error?.message || ""} ${options.url}`))
    }
    return Promise.reject(error)
  }
  return client(options).then(onSuccess).catch(onError)
}
